const Image = () => {
    return (
<svg width="92" height="44" viewBox="0 0 92 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M89.1052 10.6056C88.5988 9.23452 87.0816 8.53182 85.7106 9.03825L76.9281 12.2762C76.7246 12.3513 76.4968 12.3161 76.3253 12.1833L63.7183 2.41386C63.5466 2.28083 63.3185 2.24579 63.1148 2.32117L60.9021 3.14004C60.5147 3.28341 60.3684 3.75499 60.6066 4.09247L68.0904 14.6954C68.3288 15.0332 68.1819 15.5053 67.7938 15.6482L60.3396 18.3926C60.1537 18.461 59.9465 18.4379 59.7803 18.3302L56.6077 16.274C56.4413 16.1662 56.2337 16.1431 56.0476 16.2119L54.6259 16.7374C54.2384 16.8807 54.0919 17.3523 54.3301 17.6899L57.5635 22.272L58.8424 24.0829C59.0066 24.3154 59.3065 24.4086 59.5735 24.3102L61.8717 23.4633L70.9813 20.1047L78.4283 17.3589L87.5379 14.0003C88.9089 13.4938 89.6116 11.9767 89.1052 10.6056Z" fill="white"/>
<path d="M23.5189 37.9338L60.7678 23.9153L60.2646 18.4182L3.20755 43.1188L23.5189 37.9338Z" fill="url(#paint0_linear_752_26373)"/>
<defs>
<linearGradient id="paint0_linear_752_26373" x1="60.5032" y1="20.6417" x2="40.4795" y2="28.7897" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>


    )
}

export default Image
